import "./styles/index.css";
import { withSentryReactRouterV6Routing } from "@sentry/react";
import { Route, Routes } from "react-router-dom";
import Start from "./views/start";
import Apps from "./views/apps";
import Info from "./views/info";
import Header from "./components/header";
import YouFind from "./views/you_find";
import YouData from "./views/you_data";
import YouGame from "./views/you_game";
import YouGenerate from "./views/you_generate";
import YouMail from "./views/you_mail";
import YouShareOverview from "./views/you_share/overview";
import YouShareDetails from "./views/you_share/details";
import YouSnap from "./views/you_snap";
import Einde from "./views/einde";
import YouTalk from "./views/you_talk";

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export default function App() {
  return (
    <main className="main-container">
      <Header />
      <SentryRoutes>
        <Route path="/" element={<Start />} />
        <Route path="/apps" element={<Apps />} />
        <Route path="/einde" element={<Einde />} />
        <Route path="/info" element={<Info />} />
        <Route path="/youfind" element={<YouFind />} />
        <Route path="/youdata" element={<YouData />} />
        <Route path="/yougame" element={<YouGame />} />
        <Route path="/yougenerate" element={<YouGenerate />} />
        <Route path="/youmail" element={<YouMail />} />
        <Route path="/youshare" element={<YouShareOverview />} />
        <Route path="/youshare_details" element={<YouShareDetails />} />
        <Route path="/youtalk" element={<YouTalk />} />
        <Route path="/yousnap" element={<YouSnap />} />
      </SentryRoutes>
    </main>
  );
}
